import { useCallback } from "react";
import useSWR from "swr";
import { useApi } from "../api";
import { CustomError } from "../errors";

export const usePermissionsApi = () => {
  const api = useApi();

  const useAdminPermissions = useCallback(
    (signal: AbortSignal) => {
      const url = "/admin/permissions";
      return useSWR<string[], CustomError, string>(url, (url) => api.get<string[]>({ url, signal }));
    },
    [api]
  );
  return {
    useAdminPermissions,
  };
};
